import { rootUrl as baseUrl } from './shared';
export const organization = {
  '@context': 'http://schema.org/',
  '@type': 'Organization',
  '@id': `${baseUrl}/#organization`,
  name: 'hipages',
  address: {
    '@type': 'PostalAddress',
    '@id': `${baseUrl}/#postalAddress`,
    streetAddress: 'Level 10, 255 Pitt Street',
    addressLocality: 'Sydney',
    addressRegion: 'New South Wales',
    addressCountry: 'Australia',
    postalCode: 'NSW 2000'
  },
  contactPoint: [
    {
      '@type': 'ContactPoint',
      '@id': `${baseUrl}/#contactpoint`,
      contactType: 'Customer Support',
      email: 'support@hipages.com.au',
      url: `${baseUrl}/contactus`
    }
  ],
  logo: {
    '@type': 'ImageObject',
    '@id': `${baseUrl}/#logo`,
    url: 'https://assets.homeimprovementpages.com.au/images/hipages-logo-simple.png',
    width: 120,
    height: 44
  },
  sameAs: [
    'https://www.facebook.com/hipages',
    'https://twitter.com/hipages',
    'https://www.linkedin.com/company/hipages-group/',
    'https://www.pinterest.com.au/hipages',
    'https://instagram.com/hipages'
  ],
  url: `${baseUrl}`
};
